import { render, staticRenderFns } from "./NewBook.vue?vue&type=template&id=d8e98b98&"
import script from "./NewBook.vue?vue&type=script&lang=js&"
export * from "./NewBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports